// extracted by mini-css-extract-plugin
export default {"mainContainer":"_7SrChFdabElqPFyi9GyQ9A==","content":"vKI2nIzdaU2Eg45SbldWjg==","icon":"-mPbmwNft7DnSEpsFGvsOw=="};